<template>
  <section>
    <top-menu/>

    <!-- Loading from page -->
    <full-loading v-if="loadingBenefitsRequests"/>

    <section v-else>
      <div class="page-content">
        <div class="container-fluid">
          <div class="col-xs-12 col-sm-12 col-md-12 table-box">
            <div class="table-box--header">
              <span class="table-box--header-title">
                <ion-icon name="card-outline"></ion-icon>
                Pedidos de benefícios
              </span>
              <span class="table-box--header-subtitle">
                Gerencie os pedidos de saldo efetuados pelas empresas
              </span>
            </div>
            <div class="content-benefits-requests">
              <datapicker-global @initDate="value => dataSearch.initDate = value"
                                 @endDate="value => dataSearch.endDate = value" col="4" variable-name="benefitsDate"
                                 have-range-days-max=""
                                 range-days-init="45"
                                 label="Data Inicio/fim"/>
              <input-text @contentText="value => dataSearch.companyId = value" col="4" type="text"
                          placeholder="Digite um id" label="Id da empresa"/>
              <input-text @contentText="value => dataSearch.companyName = value" col="4" type="text"
                          placeholder="Digite um nome" label="Nome da empresa"/>
              <input-text @contentText="value => dataSearch.requestId = value" col="4" type="text"
                          placeholder="Digite um id" label="Id do Pedido"/>
              <input-currency @contentCurrency="value => dataSearch.currency = value" col="4"
                              placeholder="Digite um valor" label="Valor"/>
              <input-select @selectedOption="value => dataSearch.status = value" col="4" :options="optionsStatus"
                            label="Status"/>
              <btn-custom col="6" @emit-click="getList()" label="Filtrar" which-side="left"/>
              <btn-custom v-if="contentBenefitsRequests.length" have-loading="true" :loading="loadingExcel" col="6"
                          @emit-click="getExcel()" label="Excel"
                          icon="excel" which-side="right" btn-color="green"/>
            </div>
            <full-loading class="full-loading-list" v-if="loadingListBenefits"/>
            <div v-if="!loadingListBenefits" class="table-box--content">
              <div v-if="contentBenefitsRequests.length === 0" class="empty-state-group">
                <img src="../../../../assets/img/empty-state.png" alt="empty-state">
                <div class="empty-state-text">
                  <span class="empty-state-title">Nenhum cancelamento encontrado</span>
                  <span class="empty-state-subtitle">Caso esteja realizando alguma pesquisa, verifique os dados preenchidos e tente novamente!</span>
                </div>
              </div>
              <table v-else class="content-table">
                <thead>
                <tr>
                  <th>
                    Id do pedido
                  </th>
                  <th>
                    Nome da empresa
                    <ion-icon id="name" v-on:click="orderSort('name')"
                              name="caret-down-outline"></ion-icon>
                  </th>
                  <th>
                    Status
                    <ion-icon id="status" v-on:click="orderSort('status')"
                              name="caret-down-outline"></ion-icon>
                  </th>
                  <th>
                    Valor
                    <!--                    <ion-icon id="value" v-on:click="orderSort('value')"-->
                    <!--                              name="caret-down-outline"></ion-icon>-->
                  </th>
                  <th>
                    Criação do pedido
                    <ion-icon id="updatedAt" v-on:click="orderSort('updatedAt')"
                              name="caret-down-outline"></ion-icon>
                  </th>
                  <th>
                    Pagamento efetuado
                    <ion-icon id="paidAt" v-on:click="orderSort('paidAt')"
                              name="caret-down-outline"></ion-icon>
                  </th>
                  <th>Ações</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(value, index) in contentBenefitsRequests" :key="index">
                  <td class="content-table--company-id">
                    {{ value.id }}
                  </td>
                  <td class="content-table--company-name">
                    {{ value.name }}
                  </td>
                  <td class="content-table--status">
                    <span v-if="value.status === 0" class="none">
                      Nenhum
                    </span> <span v-if="value.status === 1" class="draw">
                      Rascunho
                    </span> <span v-if="value.status === 2" class="waiting">
                      Aguardando
                    </span> <span v-if="value.status === 3" class="paid">
                      Pago
                    </span> <span v-if="value.status === 4" class="canceled">
                      Cancelado
                    </span>
                  </td>
                  <td class="content-table--value">
                    {{ value.value }}
                  </td>
                  <td class="content-table--created">
                    <div class="content-table--created-date">
                      {{ value.updatedAt | formatDate }} <span> às {{ value.updatedAt | formatHors24 }} </span>
                    </div>
                    <span id="batata"></span>
                  </td>
                  <td class="content-table--created">
                    <div v-if="value.status === 3" class="content-table--created-date">
                      {{ value.paidAt | formatDate }} <span> às {{ value.paidAt | formatHors24 }} </span>
                    </div>
                    <div v-else></div>
                  </td>
                  <td class="content-table--actions">
                    <div class="buttons-actions">
                      <button>
                        <ion-icon name="chevron-forward"></ion-icon>
                      </button>
                      <button v-if="value.status === 2" class="confirm-payment" title="Confirmar pagamento"
                              v-on:click="openModalPayment(value.companyId, value.id, value.contextCode)">
                        <ion-icon name="cash-outline" title="Confirmar pagamento"></ion-icon>
                      </button>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <modal-password
      titleModal="Entrada de fundos"
      subtitleModal="Confirmar a entrada de fundos na conta do cliente?"
      :runFunction="confirmPayment"
    />
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import modalPassword from "../../modals/modalPassword";
import {ALL_COMPANY, CONFIRM_PAYMENT_BENEFITS, ORDERS_BENEFITS} from "../../../../urlConfig";
import {REQUEST_SERVICE, UTIL_SERVICE} from "../../../../requestConfig";
import swal from "sweetalert";
import moment from "moment";
import {ALERT_SERVICE} from "../../../../msgAlertService";
import DatapickerGlobal from "../../components/inputs/datapickerGlobal.vue";
import InputText from "../../components/inputs/inputText.vue";
import InputSelect from "../../components/inputs/inputSelect.vue";
import InputCurrency from "../../components/inputs/inputCurrency.vue";
import BtnSearch from "../../components/buttons/btnSearch.vue";
import BtnCustom from "../../components/buttons/btnCustom.vue";

export default {
  name: "benefits-requests",
  components: {
    BtnCustom,
    BtnSearch,
    InputCurrency,
    InputSelect,
    DatapickerGlobal,
    InputText,
    topMenu,
    pageHeader,
    fullLoading,
    modalPassword
  },
  data() {
    return {
      loadingBenefitsRequests: false,
      contentBenefitsRequests: '',
      idRequest: '',
      balanceRequest: '',
      contextCode: '',
      dataSearch: {
        initDate: '',
        endDate: '',
        companyId: '',
        companyName: '',
        requestId: '',
        status: '',
        currency: '',
      },
      optionsStatus: [
        {
          name: 'Selecione',
          id: ''
        },
        {
          name: 'Nenhum',
          id: 0
        },
        {
          name: 'Rascunho',
          id: 1
        },
        {
          name: 'Aguardando',
          id: 2
        },
        {
          name: 'Pago',
          id: 3
        },
        {
          name: 'Cancelado',
          id: 4
        },
      ],
      loadingListBenefits: false,
      loadingExcel: false,
    };
  },
  methods: {
    setDateInitial() {
      const date = new Date();
      this.dataSearch.initDate = moment(date).subtract(45, 'days').format('YYYY-MM-DD');
      this.dataSearch.endDate = moment(date).format('YYYY-MM-DD');
    },
    getList() {
      this.loadingListBenefits = true;

      let url = ORDERS_BENEFITS;
      url += '?init=' + this.dataSearch.initDate + '&end=' + this.dataSearch.endDate

      if (this.dataSearch.companyId) {
        url += '&companyId=' + this.dataSearch.companyId
      }

      if (this.dataSearch.companyName) {
        url += '&companyName=' + this.dataSearch.companyName
      }

      if (this.dataSearch.requestId) {
        url += '&orderId=' + this.dataSearch.requestId
      }

      if (this.dataSearch.status) {
        url += '&status=' + this.dataSearch.status
      }

      if (this.dataSearch.currency && this.dataSearch.currency > 0 && this.dataSearch.currency !== 0.00) {
        url += '&balance=' + this.dataSearch.currency
      }

      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.get(url).then((response) => {
        UTIL_SERVICE.console("RESULT ORDERS_BENEFITS:", response.data);

        this.contentBenefitsRequests = response.data;
        this.loadingListBenefits = false;
      }).catch((reason) => {
        this.loadingListBenefits = false;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    getExcel() {
      this.loadingExcel = true

      let bodyValue = [];
      let headValue = ["ID DO PEDIDO", "NOME DA EMPRESA", "STATUS", "VALOR", "CRIACAO DO PEDIDO", "PAGAMENTO EFETUADO"];

      this.contentBenefitsRequests.map((value, index) => {

        bodyValue.push([value.id, value.name, value.statusStr, value.value, moment(String(value.updatedAt)).format('DD/MM/YYYY'), value.paidAt,]);

        setTimeout(() => {
          this.loadingExcel = false
        }, 1000);
      });

      setTimeout(() => {
        window.downloadListExcel(headValue, bodyValue, "Pedidos de benefícios");
      }, 500);
    },
    openModalPayment(id, balance, context) {
      this.idRequest = id;
      this.balanceRequest = balance;
      this.contextCode = context;

      document.querySelector("[id='input-password']").value = "";
      $("#password-modal").modal();
    },
    confirmPayment(password) {

      const obj = {
        companyId: this.idRequest,
        balanceOrderId: this.balanceRequest,
        password: password
      };

      UTIL_SERVICE.console("Data send:", obj);
      REQUEST_SERVICE.post(CONFIRM_PAYMENT_BENEFITS, obj)
        .then((response) => {
          UTIL_SERVICE.console("RESULT CONFIRM_PAYMENT_BENEFITS:", response.data);

          swal("Successo!", "Pagamento confirmado com sucesso!", "success");

        })
        .catch((reason) => {
          console.log(reason.response.data.erros[0].value)
          swal("Erro!", reason.response.data.erros[0].value, "error");
        });
    },
    orderSort(value) {
      $('#updatedAt').css('transform', 'rotate(0deg)');
      $('#status').css('transform', 'rotate(0deg)');
      $('#value').css('transform', 'rotate(0deg)');
      $('#name').css('transform', 'rotate(0deg)');

      this.contentBenefitsRequests = this.contentBenefitsRequests.sort(function (a, b) {
        let valueA = a[value];
        let valueB = b[value];
        if (typeof valueA === 'string') {
          valueA = valueA.toLowerCase().trim();
        }

        if (typeof valueB === 'string') {
          valueB = valueB.toLowerCase().trim();
        }

        if (valueA > valueB) {
          return 1;
        }
        if (valueA < valueB) {
          return -1;
        }
        return 0;
      });

      if (this[value + 'Order'] === true) {
        this.contentBenefitsRequests.reverse();
        $('#' + value).css('transform', 'rotate(0deg)');
      } else {
        $('#' + value).css('transform', 'rotate(180deg)');
      }

      this[value + 'Order'] = !this[value + 'Order']
    },
  },
  beforeMount() {
    this.setDateInitial();
    this.getList();
  },
}
</script>

<style lang="scss" scoped>
.container-fluid {
  .table-box {
    padding: 20px 30px;
    background: var(--classic-white);
    border-radius: 10px !important;

    .table-box--header {
      .table-box--header-title {
        display: flex;
        align-items: center;

        font-size: 18px;
        font-weight: 700;
        color: var(--classic-black);

        ion-icon {
          margin-right: 5px;
          font-size: 23px;
          color: var(--dark-gray);
        }
      }

      .table-box--header-subtitle {
        font-size: 14px;
        font-weight: 400;
        color: var(--dark-gray);
      }

      .row {
        margin: 0;
      }

      .table-box--form {
        display: flex;
        margin-top: 25px;

        &:last-of-type {
          margin-top: 15px;
        }

        .form-text-1 {
          display: flex;
          flex-direction: column;
          padding: 0;
          margin-right: 15px;

          label {
            font-size: 14px;
            font-weight: 400;
            color: var(--border-gray);
          }

          .form-text-1-input {
            display: flex;
            position: relative;

            ion-icon {
              position: absolute;
              right: 10px;
              top: 10px;
              font-size: 16px;
              color: var(--dark-gray);
            }

            input {
              width: 100%;
              background: #EEF2F7;
              border-radius: 4px !important;
              padding: 6px 12px;
              border: 1px solid #EEF2F7;
              transition: .2s;

              font-size: 16px;
              font-weight: 400;
              color: var(--dark-gray);

              &::placeholder {
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
              }

              &:hover {
                transition: .2s;
                border: 1px solid #CACACA;
              }

              &:focus-visible {
                outline: none;
                transition: .2s;
                border: 1px solid #CACACA;

                &::placeholder {
                  transition: .1s;
                  color: #EEF2F7;
                }
              }
            }
          }
        }

        .form-text-2 {
          display: flex;
          flex-direction: column;
          padding: 0;
          margin-right: 15px;
          margin-left: 15px;

          label {
            font-size: 14px;
            font-weight: 400;
            color: var(--border-gray);
          }

          .form-text-2-input {
            display: flex;
            position: relative;

            ion-icon {
              position: absolute;
              right: 10px;
              top: 10px;
              font-size: 16px;
              color: var(--dark-gray);
            }

            input {
              width: 100%;
              background: #EEF2F7;
              border-radius: 4px !important;
              padding: 6px 12px;
              border: 1px solid #EEF2F7;
              transition: .2s;

              font-size: 16px;
              font-weight: 400;
              color: var(--dark-gray);

              &::placeholder {
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
              }

              &:hover {
                transition: .2s;
                border: 1px solid #CACACA;
              }

              &:focus-visible {
                outline: none;
                transition: .2s;
                border: 1px solid #CACACA;

                &::placeholder {
                  transition: .1s;
                  color: #EEF2F7;
                }
              }
            }
          }
        }

        .form-text-3 {
          display: flex;
          flex-direction: column;
          padding: 0;
          margin-left: 15px;

          label {
            font-size: 14px;
            font-weight: 400;
            color: var(--border-gray);
          }

          .form-text-3-input {
            display: flex;
            position: relative;

            ion-icon {
              position: absolute;
              right: 10px;
              top: 10px;
              font-size: 16px;
              color: var(--dark-gray);
            }

            input {
              width: 100%;
              background: #EEF2F7;
              border-radius: 4px !important;
              padding: 6px 12px;
              border: 1px solid #EEF2F7;
              transition: .2s;

              font-size: 16px;
              font-weight: 400;
              color: var(--dark-gray);

              &::placeholder {
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
              }

              &:hover {
                transition: .2s;
                border: 1px solid #CACACA;
              }

              &:focus-visible {
                outline: none;
                transition: .2s;
                border: 1px solid #CACACA;

                &::placeholder {
                  transition: .1s;
                  color: #EEF2F7;
                }
              }
            }
          }
        }

        .form-select {
          display: flex;
          flex-direction: column;
          padding: 0;
          margin-right: 15px;

          label {
            font-size: 14px;
            font-weight: 400;
            color: var(--border-gray);
          }

          .form-select-input {
            position: relative;

            ion-icon {
              position: absolute;
              right: 10px;
              top: 11px;
              font-size: 16px;
              color: var(--dark-gray);
              cursor: pointer;
              pointer-events: none;
            }

            select {
              width: 100%;
              background: #EEF2F7;
              border-radius: 4px !important;
              padding: 6px 12px;
              border: 1px solid #EEF2F7;
              transition: .2s;
              font-size: 16px;
              font-weight: 400;
              color: var(--dark-gray);
              cursor: pointer;

              -webkit-appearance: none;
              -moz-appearance: none;
              appearance: none;

              &::placeholder {
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
              }

              &:hover {
                transition: .2s;
                border: 1px solid #CACACA;
              }

              &:focus-visible {
                outline: none;
                transition: .2s;
                border: 1px solid #CACACA;

                &::placeholder {
                  transition: .1s;
                  color: #EEF2F7;
                }
              }
            }
          }
        }

        .form-button {
          padding-right: 0;

          button {
            width: 100%;
            height: 59%;
            margin-top: 25.5px;
            background: #2F23D6;
            color: #FFFFFF;
            border-radius: 4px !important;
            border: none;

            &:hover {
              background: #20179E;
            }
          }
        }
      }
    }

    .content-benefits-requests {
      margin-top: 25px;
      display: inline-block;
    }

    .table-box--content {
      margin-top: 25px;

      .content-table {
        width: 99%;
        max-width: 99%;
        margin-bottom: 20px;

        thead {
          font-size: 14px;
          color: var(--high-gray);
          line-height: 220%;
          padding-bottom: 5px;
          border-bottom: 1px solid var(--classic-gray);

          tr {
            th {
              font-weight: 500 !important;

              ion-icon {
                width: 13px;
                height: 13px;
                transition: .3s;
                cursor: pointer;
              }
            }
          }
        }

        tbody {
          tr {
            border-bottom: 1px solid var(--classic-gray);

            .content-table--company-id {
              width: 15%;
              color: var(--dark-gray);
              padding-right: 20px;

              a {
                display: list-item;
                width: 140px;
                white-space: nowrap;
                overflow: hidden !important;
                text-overflow: ellipsis;

                font-size: 14px;
                font-weight: 500;
                color: var(--high-blue);
                align-items: center;

                ion-icon {
                  font-size: 14px;
                  margin-right: 4px;
                }
              }
            }

            .content-table--company-name {
              width: 20%;
              color: var(--dark-gray);
              padding: 20px 0;

              a {
                display: list-item;
                width: 140px;
                white-space: nowrap;
                overflow: hidden !important;
                text-overflow: ellipsis;

                font-size: 14px;
                font-weight: 500;
                color: var(--high-blue);
                align-items: center;

                ion-icon {
                  font-size: 14px;
                  margin-right: 4px;
                }
              }
            }

            .content-table--status {
              span {
                border-radius: 4px !important;
                font-size: 12px;
                font-weight: 500;
                padding: 4px 16px;
              }

              .done {
                color: var(--classic-white);
                background: var(--dark-gray);
                padding: 4px 16px;
              }

              .draw {
                color: var(--classic-white);
                background: var(--high-blue);
                padding: 4px 24px;
              }

              .waiting {
                color: var(--dark-gray);
                background: var(--light-yellow);
                padding: 4px 16px;
              }

              .paid {
                background: var(--light-green);
                color: var(--classic-white);
                padding: 4px 38.5px;
              }

              .canceled {
                background: var(--light-red);
                color: var(--classic-white);
                padding: 4px 22px;
              }

              .pending {
                color: var(--dark-gray);
                background: var(--light-yellow);
                padding: 4px 25px;
              }

              .in-progress {
                color: var(--classic-white);
                background: var(--high-blue);
                padding: 4px 12.5px;
              }

              .concluded {
                background: var(--light-green);
                color: var(--classic-white);
                padding: 4px 25px;
              }

              .none {
                background: var(--dark-gray);
                color: var(--classic-white);
                padding: 4px 27px;
              }
            }

            .content-table--value {
              font-size: 16px;
              font-weight: 400;
              color: var(--dark-gray);
            }

            .content-table--created {
              .content-table--created-date {
                display: flex;
                flex-direction: column;
                margin-top: 11px;

                padding: 0 20px;
                font-size: 14px;
                font-weight: 400;
                color: var(--dark-gray);

                span {
                  font-size: 12px;
                  font-weight: 400;
                  color: var(--high-gray);
                }
              }

              .content-table--created-awaiting {
                color: var(--dark-gray);
              }
            }

            .content-table--actions {
              .buttons-actions {
                display: flex;
                flex-direction: row;

                button {
                  display: flex;
                  justify-content: center;
                  align-items: center;

                  background: var(--background-gray);
                  width: 32px;
                  height: 32px;
                  padding: 0;
                  border: none;
                  border-radius: 4px !important;
                  transition: 0.2s;

                  ion-icon {
                    color: var(--dark-gray);
                    font-size: 22px;
                    transition: 0.2s;
                    pointer-events: none;
                  }

                  &:hover {
                    background: var(--high-blue);

                    ion-icon {
                      color: var(--classic-white);
                    }
                  }
                }

                .confirm-payment {
                  display: flex;
                  justify-content: center;
                  align-items: center;

                  background: var(--background-gray);
                  width: 32px;
                  height: 32px;
                  padding: 0;
                  border: none;
                  border-radius: 4px !important;
                  transition: 0.2s;
                  margin-left: 10px;

                  ion-icon {
                    color: var(--dark-gray);
                    font-size: 22px;
                    transition: 0.2s;
                    pointer-events: none;
                  }

                  &:hover {
                    background: var(--light-green);

                    ion-icon {
                      color: var(--classic-white);
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .full-loading-list {
      border: none;
      box-shadow: none;
    }

    .empty-state-group {
      text-align: center;
      margin-top: 2rem;
      margin-bottom: 6rem;

      img {
        margin-bottom: 2rem;
      }

      .empty-state-text {
        display: flex;
        justify-content: center;
        flex-direction: column;

        width: 45%;
        margin: auto;

        .empty-state-title {
          font-weight: 700;
          font-size: 16px;
          color: var(--dark-gray);
        }

        .empty-state-subtitle {
          font-weight: 400;
          font-size: 16px;
          color: var(--dark-gray);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/benefits/benefits-requests.vue